import { RestClient } from './RestClient'
import store from 'src/store'

export class ItemsClient extends RestClient {
  /**
   * Items constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/items`
  }

  /**
   * Get a list of all items for the current company
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified item
   *
   * @param {(...number|number[])} id - Items to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Create a new item
   *
   * @param {Object} data - Item info
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Update an existing item
   *
   * @param {number} itemId - Item id
   * @param {Object} data   - Item info
   *
   * @returns {AxiosPromise}
   */
  update (itemId, data) {
    return this.call('patch', `${this.baseUrl}/${itemId}`, data)
  }

  /**
   * Delete the specified items
   *
   * @param {(...number|number[])} itemId - Items which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...itemId) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(itemId)}`)
  }

  /**
   * Search for items
   *
   * @param query
   * @returns {AxiosPromise}
   */
  search (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/search`)
  }
}
